module.exports = __webpack_public_path__ + "static/media/pic3.27ddcd66.jpg";